import api from "./apiConfig";

export const GET_ALL_CONTRACTS = async () => {
	try {
		const response = await api.get("/contracts");
		return response.data;
	} catch (error) {
		console.error("Error al obtener contratos:", error);
		throw error;
	}
};

export const GET_CONTRACTS_BY_CLIENT = async (clientId) => {
	try {
		const response = await api.get(`/contractsByClient/${clientId}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener contratos:", error);
		throw error;
	}
};

export const GET_CONTRACT_BY_ID = async (contractId) => {
	try {
		const response = await api.get(`/contracts/${contractId}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener contrato:", error);
		throw error;
	}
};

export const CREATE_CONTRACT = async (data) => {
	try {
		const response = await api.post("/contracts", data);
		return response.data;
	} catch (error) {
		console.error("Error al crear contrato:", error);
		throw error;
	}
};

export const UPDATE_CONTRACT = async (contractId, data) => {
	try {
		const response = await api.put(`/contracts/${contractId}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar contrato:", error);
		throw error;
	}
};

export const DELETE_CONTRACT = async (contractId) => {
	try {
		const response = await api.delete(`/contracts/${contractId}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar contrato:", error);
		throw error;
	}
};

export const GET_ALL_PAYMENTS = async () => {
	try {
		const response = await api.get("/payments");
		return response.data;
	} catch (error) {
		console.error("Error al obtener pagos:", error);
		throw error;
	}
};

export const GET_PAYMENTS_BY_CONTRACT = async (contractId) => {
	try {
		const response = await api.get(`/paymentsByContractId/${contractId}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener pagos:", error);
		throw error;
	}
};

export const GET_PAYMENT_BY_ID = async (paymentId) => {
	try {
		const response = await api.get(`/payments/${paymentId}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener pago:", error);
		throw error;
	}
};

export const CREATE_PAYMENT = async (data) => {
	try {
		const response = await api.post("/payments", data);
		return response.data;
	} catch (error) {
		console.error("Error al crear pago:", error);
		throw error;
	}
};

export const CREATE_MULTIPLE_PAYMENTS = async (payments) => {
	try {
		const responses = await Promise.all(
			payments.map(payment => api.post("/payments", payment))
		);
		return responses.map(res => res.data);
	} catch (error) {
		console.error("Error al crear múltiples pagos:", error);
		throw error;
	}
};

export const UPDATE_PAYMENT = async (paymentId, data) => {
	try {
		const response = await api.put(`/payments/${paymentId}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al actualizar pago:", error);
		throw error;
	}
};

export const DELETE_PAYMENT = async (paymentId) => {
	try {
		const response = await api.delete(`/payments/${paymentId}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar pago:", error);
		throw error;
	}
};